export default  {"src":"/_next/static/image/public/assets/icons/right-arrow.a40739dfbefdf7a15b31535818b5d715.svg","height":30,"width":17};